import { useEffect, useState } from "react";
import { api } from "./api";
import { MOCK_DATA_ENABLED } from "./dataMode";

export type LoadState = "loading" | "ready" | "notfound";

/** Fetch a listing from the API; use seeded records only in explicit mock mode. */
export function useListing<T extends { id: string }>(
  kind: "people" | "services" | "companies" | "jobs" | "projects" | "rfqs",
  id: string,
  mockList: T[],
): { item: any | null; state: LoadState } {
  const [item, setItem] = useState<any | null>(null);
  const [state, setState] = useState<LoadState>("loading");

  useEffect(() => {
    let alive = true;
    setState("loading");
    setItem(null);
    const mock = () => mockList.find((x) => x.id === id) || null;
    api.getListing(kind, id)
      .then((it) => {
        if (!alive) return;
        const resolved = it || (MOCK_DATA_ENABLED ? mock() : null);
        if (resolved) { setItem(resolved); setState("ready"); }
        else { setItem(null); setState("notfound"); }
      })
      .catch(() => {
        if (!alive) return;
        const m = MOCK_DATA_ENABLED ? mock() : null;
        if (m) { setItem(m); setState("ready"); }
        else { setState("notfound"); }
      });
    return () => { alive = false; };
  }, [kind, id]); // eslint-disable-line react-hooks/exhaustive-deps

  return { item, state };
}
